// extracted by mini-css-extract-plugin
export default {"wrapper":"thumbnail_wrapper__d7wCw","img":"thumbnail_img__4+6Lj"};